import axios from 'axios'
import { getToken, removeToken } from './storage'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '',
  timeout: 15000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    
    if (res.code !== 200) {
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    
    return res
  },
  error => {
    if (error.response) {
      const { status } = error.response
      
      if (status === 401) {
        removeToken()
        window.location.href = '/login'
      }
      
      const message = error.response.data?.message || error.message || '请求失败'
      return Promise.reject(new Error(message))
    }
    
    return Promise.reject(error)
  }
)

export default service